import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router";
import { Link } from 'react-router-dom';

import { LayoutContext } from "../layout/";

import Loader from "../loader";
import { getEndpoint } from "../helper";

export default function Products({ }) {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);

    const { setPageTitle } = useContext(LayoutContext);

    const { categoryId } = useParams();

    const formatNumber = n => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const Box = ({ id, picture, title, price, oldPrice, discount, status, status_ }) => {
        const Img = () => {
            if (picture && picture.length > 0) return <img src={getEndpoint(`/uploads/shop/product-file/${picture}`)} />;

            return <img src={getEndpoint('/pwa/img/no_pic_750x750.jpg')} />;
        }

        return (
            <Link className='bsh-4 bc-w ta-c mb-4 br-4 o-h' style={{ flex: '0 0 calc(50% - .8rem)' }} to={`/product/${id}/${categoryId}`}>
                <Img />
                <div className='p-3' style={{ color: '#757575' }}>
                    {title}
                </div>

                {
                    status == 10 && (
                        <div className='d-f ai-c px-2'>
                            <div className='d-f ai-c jc-c _bc-g-d c-w p-1 br-4'>
                                <div className='d-l fs-4'>{discount}%</div>
                            </div>
                            <div className='mr-2 fw-600'>
                                <div className='d-f ai-c mt-1'>
                                    <div className='fs-3' style={{ color: '#9c9c9c', textDecorationLine: 'line-through' }}>{formatNumber(oldPrice)}</div>
                                    &nbsp;
                                    <div style={{ color: '#9c9c9c', fontSize: '.8em' }}>ریال</div>
                                </div>
                                <div className='d-f ai-c p-r _c-b_b' style={{ top: '-.5em' }}>
                                    <div className='fs-3'>{formatNumber(price)}</div>
                                    &nbsp;
                                    <div style={{ fontSize: '.8em' }}>ریال</div></div>
                            </div>
                        </div>
                    )
                }
                {
                    status != 10 && (
                        <div className='fw-900 fs-3 d-f ai-c px-2' style={{ height: '5.5rem', color: '#6c6c6c' }}>{status_}</div>
                    )
                }
            </Link>
        );
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(getEndpoint(`/api/android/product/Get4ProductsFragment?categoryId=${categoryId}`), { signal });
                const json = await response.json();
                setData(json.data);
                setPageTitle(json.data[0]?.categoryTitle)

            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        categoryId && fetchData();

        return () => controller.abort();
    }, [categoryId]);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className='d-f fw-w jc-sb p-4' style={{ backgroundColor: '#f5f5f5', paddingBottom: '6rem' }}>
            {data.map(x => {
                return (
                    <Box
                        key={x.id}
                        id={x.id}
                        picture={x.picture}
                        title={x.title}
                        price={x.price}
                        oldPrice={x.oldPrice}
                        discount={x.discount}
                        status={x.status}
                        status_={x.status_}
                    />
                )
            })}

            {showPopup && (
                <div className='p-f l-0 t-0 w-100vw h-100vh zi-80 d-f ai-c'>
                    <div className='p-f l-0 t-0 w-100vw h-100vh zi-80' style={{ backgroundColor: 'rgba(0,0,0, .5)' }} onClick={e => setShowPopup(!showPopup)} />
                    <div className='p-r bc-w mx-4 zi-90 p-4 fs-3 bsh-2 br-2 w-100 fw-600' style={{ fontSize: '.99em' }}>
                        <div className='d-f ai-c' style={{ height: '5rem' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
                                <path fill='#4caf50' d="M20.563 20.594l-1.875 1.875-8-8 8-8 1.875 1.875-6.125 6.125z"></path>
                            </svg>
                            <div className='mr-2'>شرکت ها و محصولات</div>
                        </div>
                        <div style={{ height: '1px', backgroundColor: '#e6e6e6' }}></div>
                        <div className='d-f ai-c p-r' style={{ height: '5rem', top: '.5em' }}>
                            <div>
                                <div className='d-f ai-c'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
                                        <path fill='#4caf50' d="M20.563 20.594l-1.875 1.875-8-8 8-8 1.875 1.875-6.125 6.125z"></path>
                                    </svg>
                                    <div className='mr-2'>پیش فاکتور</div>
                                </div>
                                <div style={{ color: '#8b8b8b', fontSize: '.8em', marginRight: '2.4rem' }}>
                                    دریافت آنلاین پیش فاکتور از شرکت های همراه ما
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}